<p>registrosobra works!</p>
<div class="p-6 bg-gray-900 text-white rounded-md max-w-lg">
    <form [formGroup]="formulario" (ngSubmit)="enviarFormulario()">

      <!-- Capitulo 1 -->
      <div class="mt-4">
        <label class="block text-lg font-bold">Capitulo 1</label>
        <label class="block text-lg font-bold">Agregar Paginas</label>
        <p>Solo se aceptan imágenes jpg, jpeg, png de tamaño máximo de 1,920×2,560</p>
        <div class="upload-container"
             (click)="triggerFileInputPages()" 
             (dragover)="onDragOverPages($event)" 
             (dragleave)="onDragLeavePages($event)" 
             (drop)="onDropPages($event)" 
             [class.dragover]="isDraggingPages">
            <p>Arrastra y suelta los archivos aquí o haz clic para seleccionar</p>
            <input type="file" #fileInputPages (change)="onFilesSelectedPages($event)" multiple hidden accept="image/jpeg, image/png">
        </div>
      </div>

      <div *ngIf="selectedPages.length > 0" class="files-container">
        <h3>📁 Páginas seleccionadas</h3>
        <ul>
          <li *ngFor="let file of selectedPages; let index = index" class="file-item">
            <div class="file-info">
              <button (click)="removePage(index)" class="remove-btn">❌</button>
              <span class="file-name">{{ file.name }}</span>
              <span class="file-size">{{ formatSize(file.size) }}</span>
            </div>
          </li>
        </ul>
      </div>
  
      <!-- Botón de Envío -->
      <button 
        type="submit"
        class="mt-6 w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-2 px-4 rounded"
      >
        Enviar
      </button>
    </form>
  </div>